import NetworkProvider from '../Provider';

const url = '/api/v1/user-notification';
const urlMarkRead = url+ '/mark-read';

const getDiscoveries = async () => {
  return NetworkProvider().get(url);
};

const getDiscoveryDetail = async (id) => {
  return NetworkProvider().get(`${url}/${id}`);
};

const markRead = async (id) => {
  return NetworkProvider().post(`${urlMarkRead}/${id}`);
};

export {
  getDiscoveries,
  getDiscoveryDetail,
  markRead,
};